export default __webpack_public_path__ + "static/media/what-we-offers-05.a952992e.jpg";